import { Route } from '@angular/router';

export const kanziLocationManagementRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/administration/locations/warehouses',
    pathMatch: 'full',
  },
  {
    path: 'warehouses',
    loadComponent: () =>
      import('./pages/warehouse-wms-list').then(
        (m) => m.KanziWarehouseWmsListComponent
      ),
    data: {
      breadcrumb: 'menu_breadcrumb.warehouse_list',
    },
  },
  {
    path: 'warehouses-create',
    loadComponent: () =>
      import('./pages/warehouse-create').then(
        (m) => m.WarehouseCreateComponent
      ),
    data: {
      breadcrumb: 'menu_breadcrumb.warehouse_create',
    },
  },
  {
    path: 'location-create',
    loadComponent: () =>
      import('./pages/location-create').then(
        (m) => m.LocationCreateComponent
      ),
    data: {
      breadcrumb: 'menu_breadcrumb.zone_create',
    },
  },
  {
    path: 'warehouses-create/:id',
    loadComponent: () =>
      import('./pages/warehouse-create').then(
        (m) => m.WarehouseCreateComponent
      ),
    data: {
      breadcrumb: 'menu_breadcrumb.warehouse_edit',
    },
  },
  {
    path: 'location-create/:id',
    loadComponent: () =>
      import('./pages/location-create').then(
        (m) => m.LocationCreateComponent
      ),
    data: {
      breadcrumb: 'menu_breadcrumb.zone_edit',
    },
  },
  {
    path: 'positions',
    loadComponent: () =>
      import('./pages/warehouse-wms-location-list').then(
        (m) => m.KanziWarehouseWmsLocationListComponent
      ),
    data: {
      breadcrumb: 'menu_breadcrumb.locations_list',
    },
  },
];
